var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09082 2.05H4.09082L6.75082 14.47C6.8484 14.9249 7.10149 15.3315 7.46653 15.6199C7.83157 15.9082 8.28573 16.0604 8.75082 16.05H18.5308C18.986 16.0493 19.4273 15.8933 19.7818 15.6078C20.1364 15.3224 20.383 14.9245 20.4808 14.48L22.1308 7.05H5.16082M9.04082 21C9.04082 21.5523 8.5931 22 8.04082 22C7.48854 22 7.04082 21.5523 7.04082 21C7.04082 20.4477 7.48854 20 8.04082 20C8.5931 20 9.04082 20.4477 9.04082 21ZM20.0408 21C20.0408 21.5523 19.5931 22 19.0408 22C18.4885 22 18.0408 21.5523 18.0408 21C18.0408 20.4477 18.4885 20 19.0408 20C19.5931 20 20.0408 20.4477 20.0408 21Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.abedbbe98fc5df68ec183844dd34595f.svg";
export { ForwardRef as ReactComponent };